egtoMobileNumber.$inject = [];

export function egtoMobileNumber() {
    return {
        require: '^form',
        bindToController: {
            label: '@',
            number: "=",
            name: '@'
        },
        restrict: 'E',
        scope: {},
        controller: EgtoMobileNumberController,
        controllerAs: 'vm',
        templateUrl: 'app/components/mobile-number.directive.html',
        link: link
    };

    function link(scope, element, attributes, form) {
        scope.vm.field = form[scope.vm.number];
    }
}
class EgtoMobileNumberController {
    constructor() {
    }
}
EgtoMobileNumberController.$inject = [];